import { twMerge } from "tailwind-merge";
import { IconsProps } from ".";

export const Connected = ({
  className = "text-primary",
  viewBox = "0 0 272 272",
  width = 272,
  height = 272,
  disabled = false,
  onClick,
}: IconsProps) => (
  <svg
    className={twMerge(disabled ? "opacity-20" : "cursor-pointer", className)}
    viewBox={viewBox}
    width={`${width}px`}
    height={`${height}px`}
    xmlns="http://www.w3.org/2000/svg"
    onClick={disabled ? undefined : onClick}
    fill="none"
    stroke="currentColor"
    strokeWidth="27.1667"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <title>Connected</title>
    <path d="M258.25 136H218.015C215.154 136 213.724 136 212.514 136.567C211.445 137.068 210.503 137.88 209.778 138.925C208.956 140.11 208.531 141.709 207.682 144.907L182.994 237.89C179.838 249.777 178.26 255.72 175.883 257.26C173.83 258.59 171.333 258.579 169.288 257.23C166.921 255.669 165.382 249.712 162.304 237.798L109.696 34.2023C106.618 22.2879 105.079 16.3307 102.712 14.7695C100.667 13.4207 98.1705 13.4096 96.1168 14.7401C93.7398 16.2801 92.1618 22.2234 89.0057 34.11L64.3178 127.093C63.4687 130.291 63.0441 131.89 62.2222 133.075C61.4966 134.12 60.5549 134.932 59.4865 135.433C58.2763 136 56.8457 136 53.9846 136H13.75" />
  </svg>
);
